import * as types from '../constants/ActionTypes';
import { loadUserData, loadUserInfo, saveEvent, favoriteChat } from "../services/firebase/user";

export function deleteUserStore(payload) {
  return {
    type: types.DELETE_USER,
    userData: payload,
  };
}

export function loadUserClaimsAction(user) {
  return (dispatch) => {
    loadUserData(user).then((claims) => {
      dispatch(addUserClaimsStore(claims));

      return claims
    });
  };
}

export function addUserClaimsStore(payload) {
  return {
    type: types.ADD_USER_CLAIMS,
    payload,
  };
}

export function loadUserDataAction(userID) {
  return (dispatch) => {
    return loadUserInfo(userID)
      .then((userData) => {
        dispatch(addUserDataStore(userData));

        return userData
      });
  };
}

export function addUserDataStore(payload) {
  return {
    type: types.ADD_USER_DATA,
    payload,
  };
}

// === FAVORITE CHAT ===
export function makeChatFavorite(payload) {
  return (dispatch) => {
    dispatch(makeChatFavoriteStart());

    favoriteChat(payload.uid, payload.newFavoriteChats).then(data => {
      dispatch(makeChatFavoriteStore(payload.newFavoriteChats));
    })
    .catch(error => {
      dispatch(makeChatFavoriteFail(error));
    });
  }
}

export function makeChatFavoriteStart() {
  return {
    type: types.MAKE_CHAT_FAVORITE_START
  }
}

export function makeChatFavoriteStore(payload) {
  return {
    type: types.MAKE_CHAT_FAVORITE_SUCCESS,
    payload,
  }
}

export function makeChatFavoriteFail(payload) {
  return {
    type: types.MAKE_CHAT_FAVORITE_FAIL,
    payload
  }
}

// === SAVE EVENT ===
export function saveEventAction(payload) {
  return (dispatch) => {
    dispatch(saveEventStart());

    saveEvent(payload.uid, payload.newSavedEventList).then(data => {
      dispatch(saveEventStore(payload.newSavedEventList));
    })
    .catch(error => {
      dispatch(saveEventFail(error));
    });
  }
}

export function saveEventStart() {
  return {
    type: types.SAVE_EVENT_START
  }
}

export function saveEventStore(payload) {
  return {
    type: types.SAVE_EVENT_SUCCESS,
    payload,
  }
}

export function saveEventFail(payload) {
  return {
    type: types.SAVE_EVENT_FAIL,
    payload
  }
}



// WEBPACK FOOTER //
// ./src/actions/userStoreActions.js